import { FC, useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CloudOff, AlertTriangle } from 'lucide-react';
import { listConflicts, pendingCount } from '@/utils/offlineOutbox';

/** 离线状态条（B5）：断网/队列待重放/冲突待处理时挂在顶栏下方，一点即达冲突中心。 */
const OfflineStatusBar: FC = () => {
  const navigate = useNavigate();
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);
  const [conflicts, setConflicts] = useState(0);

  const refresh = useCallback(async () => {
    try {
      setPending(await pendingCount());
      setConflicts((await listConflicts()).length);
    } catch { /* IndexedDB 不可用时不显示 */ }
  }, []);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    window.addEventListener('molore-outbox-change', refresh);
    void refresh();
    const t = setInterval(refresh, 15_000);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
      window.removeEventListener('molore-outbox-change', refresh);
      clearInterval(t);
    };
  }, [refresh]);

  if (online && pending === 0 && conflicts === 0) return null;

  return (
    <button
      onClick={() => navigate('/settings/data')}
      className={`flex-shrink-0 z-30 w-full px-4 py-1.5 flex items-center justify-center gap-2 text-[11.5px] border-b transition-colors
        ${online
          ? 'bg-warning/10 border-warning/30 text-warning'
          : 'bg-danger/10 border-danger/30 text-danger'}`}
    >
      {online ? <AlertTriangle className="w-3.5 h-3.5" /> : <CloudOff className="w-3.5 h-3.5" />}
      {!online && <span>离线中——改动会存入本地队列，联网后自动同步</span>}
      {online && pending > 0 && <span>离线队列：{pending} 条改动待同步…</span>}
      {conflicts > 0 && <span className="font-medium">冲突 {conflicts} 条待处理（点这里）</span>}
    </button>
  );
};

export default OfflineStatusBar;
